import { Component, computed, effect, EventEmitter, Input, input, Output, viewChild } from '@angular/core';
import { SwiperComponent } from '../../../common/components';
import { Breakpoint, NodeModel } from '../../../common/models';
import { LearningPathCardComponent } from '../../../learning-path-card/components/learning-path-card/learning-path-card.component';


@Component({
    selector: 'lib-learning-paths-widget',
    templateUrl: './learning-paths-widget.component.html',
    styleUrls: ['./learning-paths-widget.component.scss'],
    standalone: false
})
export class LearningPathsWidgetComponent {
  @Input() public paths: NodeModel[] = [];
  @Input() public textColor: string;
  @Input() public title: string;
  @Input() public langcode: string;
  public previewContainerBreakpoint = input<Breakpoint>();

  public swiperComponent = viewChild(SwiperComponent);

  @Output() public navigateToPath: EventEmitter<NodeModel> = new EventEmitter();
  @Output() public startPath: EventEmitter<{ item: NodeModel, component: LearningPathCardComponent }> = new EventEmitter();

  public carouselConfig = computed(() => {
    const breakpoint = this.previewContainerBreakpoint();

    const mobileConfig = {
      slidesPerView: 1,
      reducedWidth: true,
      showOverflow: true
    };

    const desktopConfig = {
      slidesPerView: 1,
      reducedWidth: false,
      showOverflow: false
    };

    if (breakpoint === Breakpoint.MOBILE) {
      return {
        breakpoints: {
          0: mobileConfig,
          480: mobileConfig
        }
      };
    }

    return {
      breakpoints: {
        0: mobileConfig,
        480: desktopConfig
      }
    };
  });

  constructor() {
    effect(() => {
      const breakpoint = this.previewContainerBreakpoint();
      const swiperComponent = this.swiperComponent();

      if (!swiperComponent?.swiper || !breakpoint) {
        return;
      }

      const bp: 0 | 480 = swiperComponent.swiper.currentBreakpoint ?? 0;
      const config = this.carouselConfig();
      const bpParams = config?.breakpoints?.[bp] ?? config;

      Object.assign(swiperComponent.swiper.params, bpParams);
      swiperComponent.swiper.update();
    });
  }
}
